var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { cloneElement, isValidElement, } from 'react';
import clsx from 'clsx';
export const Icon = (props) => {
    var _a;
    const { children, className } = props, rest = __rest(props, ["children", "className"]);
    return isValidElement(children) ? (cloneElement(children, Object.assign({ 'aria-hidden': true, focusable: false, className: clsx(className, (_a = children === null || children === void 0 ? void 0 : children.props) === null || _a === void 0 ? void 0 : _a.className) }, rest))) : (React.createElement(React.Fragment, null, children));
};
//# sourceMappingURL=Icon.js.map